import { render, staticRenderFns } from "./payout-value-page.vue?vue&type=template&id=497e0aaa&scoped=true"
import script from "./payout-value-page.vue?vue&type=script&lang=js"
export * from "./payout-value-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497e0aaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('497e0aaa')) {
      api.createRecord('497e0aaa', component.options)
    } else {
      api.reload('497e0aaa', component.options)
    }
    module.hot.accept("./payout-value-page.vue?vue&type=template&id=497e0aaa&scoped=true", function () {
      api.rerender('497e0aaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/online-transaction/payout-value-page.vue"
export default component.exports